/**
 * Récupère le token d'authentification depuis le stockage local
 * @returns {string|null} Le token JWT ou null s'il n'existe pas
 */
export const getAuthToken = () => {
  return localStorage.getItem('token') || null;
};

/**
 * Vérifie si l'utilisateur est authentifié
 * @returns {boolean} true si authentifié, false sinon
 */
export const isAuthenticated = () => {
  return !!getAuthToken();
};

/**
 * Définit le token d'authentification
 * @param {string} token Le token JWT
 */
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
};

/**
 * Déconnecte l'utilisateur en supprimant les données d'authentification
 */
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('userType');
  window.location.href = '/login';
};
